// extracted by mini-css-extract-plugin
export default {"header":"CancelThroughSupport--header--89f362","button":"CancelThroughSupport--button--a05773"};